module.exports = __webpack_public_path__ + "static/media/enter-email-migrate-guru.2d7ba156.png";